import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonService } from '../Services/common.service';

@Component({
    selector: 'app-refund-policy',
    templateUrl: './refund-policy.component.html',
    styleUrls: ['./refund-policy.component.css'],
    standalone: false
})
export class RefundPolicyComponent implements OnInit, OnDestroy {
  isMobileView = false;
  subscription: Subscription;
  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}